<template>

</template>

<script>
export default {
name: "CompanyDocumentsComponent"
}
</script>

<style scoped>

</style>